export const russianFlashcards = {
  categories: [
    {
      ru: "Здравствуйте",
      rm: "Zdravstvuyte",
      en: "Hello (formal)",
    },
    {
      ru: "Привет",
      rm: "Privet",
      en: "Hi (informal)",
    },
    {
      ru: "Доброе утро",
      rm: "Dobroye utro",
      en: "Good morning",
    },
    {
      ru: "Добрый день",
      rm: "Dobryy den'",
      en: "Good afternoon / Good day",
    },
    {
      ru: "Добрый вечер",
      rm: "Dobryy vecher",
      en: "Good evening",
    },
    {
      ru: "До свидания",
      rm: "Do svidaniya",
      en: "Goodbye (formal)",
    },
    {
      ru: "Пока",
      rm: "Poka",
      en: "Bye (informal)",
    },
    {
      ru: "Спасибо",
      rm: "Spasibo",
      en: "Thank you",
    },
    {
      ru: "Большое спасибо",
      rm: "Bol'shoye spasibo",
      en: "Thank you very much",
    },
    {
      ru: "Пожалуйста",
      rm: "Pozhaluysta",
      en: "Please / You're welcome",
    },
    {
      ru: "Извините",
      rm: "Izvinite",
      en: "Excuse me / Sorry",
    },
    {
      ru: "Простите",
      rm: "Prostite",
      en: "Forgive me / Sorry (more formal)",
    },
    {
      ru: "Да",
      rm: "Da",
      en: "Yes",
    },
    {
      ru: "Нет",
      rm: "Net",
      en: "No",
    },
    {
      ru: "Хорошо",
      rm: "Khorosho",
      en: "Okay / Good",
    },
    {
      ru: "Я не понимаю",
      rm: "Ya ne ponimayu",
      en: "I don't understand",
    },
    {
      ru: "Вы говорите по-английски?",
      rm: "Vy govorite po-angliyski?",
      en: "Do you speak English? (formal)",
    },
    {
      ru: "Ты говоришь по-английски?",
      rm: "Ty govorish' po-angliyski?",
      en: "Do you speak English? (informal)",
    },
    {
      ru: "Как дела?",
      rm: "Kak dela?",
      en: "How are you? (informal)",
    },
    {
      ru: "Как ваши дела?",
      rm: "Kak vashi dela?",
      en: "How are you? (formal)",
    },
    {
      ru: "Как жизнь?",
      rm: "Kak zhizn'?",
      en: "How's life?",
    },
    {
      ru: "Всё хорошо, спасибо",
      rm: "Vsyo khorosho, spasibo",
      en: "I'm fine, thank you",
    },
    {
      ru: "Как вас зовут?",
      rm: "Kak vas zovut?",
      en: "What's your name? (formal)",
    },
    {
      ru: "Как тебя зовут?",
      rm: "Kak tebya zovut?",
      en: "What's your name? (informal)",
    },
    {
      ru: "Меня зовут...",
      rm: "Menya zovut...",
      en: "My name is...",
    },
    {
      ru: "Где находится...?",
      rm: "Gde nahoditsya...?",
      en: "Where is...?",
    },
    {
      ru: "Где туалет?",
      rm: "Gde tualet?",
      en: "Where is the toilet?",
    },
    {
      ru: "Где вокзал?",
      rm: "Gde vokzal?",
      en: "Where is the train station?",
    },
    {
      ru: "Где аэропорт?",
      rm: "Gde aeroport?",
      en: "Where is the airport?",
    },
    {
      ru: "Сколько стоит?",
      rm: "Skol'ko stoit?",
      en: "How much does it cost?",
    },
    {
      ru: "Это очень дорого",
      rm: "Eto ochen' dorogo",
      en: "It's very expensive",
    },
    {
      ru: "Помогите!",
      rm: "Pomogite!",
      en: "Help!",
    },
    {
      ru: "Мне нужна помощь",
      rm: "Mne nuzhna pomoshch'",
      en: "I need help",
    },
    {
      ru: "Я потерялся/потерялась",
      rm: "Ya poteryalsya/poteryalas'",
      en: "I am lost (male/female)",
    },
    {
      ru: "Я ищу...",
      rm: "Ya ishchu...",
      en: "I'm looking for...",
    },
    {
      ru: "Я хотел/хотела бы...",
      rm: "Ya khotel/khotela by...",
      en: "I would like... (male/female)",
    },
    {
      ru: "Я хочу...",
      rm: "Ya khochu...",
      en: "I want...",
    },
    {
      ru: "Кофе, пожалуйста",
      rm: "Kofe, pozhaluysta",
      en: "Coffee, please",
    },
    {
      ru: "Счёт, пожалуйста",
      rm: "Schot, pozhaluysta",
      en: "The bill, please",
    },
    {
      ru: "Я вегетарианец/вегетарианка",
      rm: "Ya vegetarianets/vegetarianka",
      en: "I am vegetarian (male/female)",
    },
    {
      ru: "У меня аллергия на...",
      rm: "U menya allergiya na...",
      en: "I am allergic to...",
    },
    {
      ru: "Это вкусно",
      rm: "Eto vkusno",
      en: "It's delicious",
    },
    {
      ru: "Будем здоровы!",
      rm: "Budem zdorovy!",
      en: "Cheers! (Let's be healthy)",
    },
    {
      ru: "Я не чувствую себя хорошо",
      rm: "Ya ne chuvstvuyu sebya khorosho",
      en: "I don't feel well",
    },
    {
      ru: "Где больница?",
      rm: "Gde bol'nitsa?",
      en: "Where is the hospital?",
    },
    {
      ru: "Я немного говорю по-русски",
      rm: "Ya nemnogo govoryu po-russki",
      en: "I speak a little Russian",
    },
    {
      ru: "Пожалуйста, говорите медленнее",
      rm: "Pozhaluysta, govorite medlenneye",
      en: "Please speak slower",
    },
    {
      ru: "Можете повторить?",
      rm: "Mozhete povtorit'?",
      en: "Can you repeat that?",
    },
    {
      ru: "Я устал/устала",
      rm: "Ya ustal/ustala",
      en: "I am tired (male/female)",
    },
    {
      ru: "Какая сегодня погода?",
      rm: "Kakaya segodnya pogoda?",
      en: "What's the weather like today?",
    },
    {
      ru: "Сегодня хорошая погода",
      rm: "Segodnya khoroshaya pogoda",
      en: "The weather is good today",
    },
    {
      ru: "Жарко",
      rm: "Zharko",
      en: "It's hot",
    },
    {
      ru: "Холодно",
      rm: "Kholodno",
      en: "It's cold",
    },
    {
      ru: "Идёт дождь",
      rm: "Idyot dozhd'",
      en: "It's raining",
    },
    {
      ru: "Я согласен/согласна",
      rm: "Ya soglasen/soglasna",
      en: "I agree (male/female)",
    },
    {
      ru: "Я не согласен/согласна",
      rm: "Ya ne soglasen/soglasna",
      en: "I disagree (male/female)",
    },
    {
      ru: "Это интересно",
      rm: "Eto interesno",
      en: "It's interesting",
    },
    {
      ru: "Это важно",
      rm: "Eto vazhno",
      en: "It's important",
    },
    {
      ru: "Это возможно",
      rm: "Eto vozmozhno",
      en: "It's possible",
    },
    {
      ru: "Это невозможно",
      rm: "Eto nevozmozhno",
      en: "It's impossible",
    },
    {
      ru: "Который час?",
      rm: "Kotoryy chas?",
      en: "What time is it?",
    },
    {
      ru: "Сегодня",
      rm: "Segodnya",
      en: "Today",
    },
    {
      ru: "Завтра",
      rm: "Zavtra",
      en: "Tomorrow",
    },
    {
      ru: "Вчера",
      rm: "Vchera",
      en: "Yesterday",
    },
    {
      ru: "Сейчас",
      rm: "Seychas",
      en: "Now",
    },
    {
      ru: "Позже",
      rm: "Pozzhe",
      en: "Later",
    },
    {
      ru: "Направо",
      rm: "Napravo",
      en: "To the right",
    },
    {
      ru: "Налево",
      rm: "Nalevo",
      en: "To the left",
    },
    {
      ru: "Прямо",
      rm: "Pryamo",
      en: "Straight ahead",
    },
    {
      ru: "Близко",
      rm: "Blizko",
      en: "Near",
    },
    {
      ru: "Далеко",
      rm: "Daleko",
      en: "Far",
    },
    {
      ru: "Я потерялся/потерялась",
      rm: "Ya poteryalsya/poteryalas'",
      en: "I'm lost (male/female)",
    },
    {
      ru: "Мне плохо",
      rm: "Mne plokho",
      en: "I feel bad / I'm sick",
    },
    {
      ru: "Это срочно",
      rm: "Eto srochno",
      en: "It's urgent",
    },
    {
      ru: "Один момент, пожалуйста",
      rm: "Odin moment, pozhaluysta",
      en: "One moment, please",
    },
    {
      ru: "Я не знаю",
      rm: "Ya ne znayu",
      en: "I don't know",
    },
    {
      ru: "Всё в порядке",
      rm: "Vsyo v poryadke",
      en: "Everything is alright / It's okay",
    },
    {
      ru: "Ничего страшного",
      rm: "Nichevo strashnogo",
      en: "It's nothing serious / Don't worry",
    },
    {
      ru: "Нет проблем",
      rm: "Net problem",
      en: "No problem",
    },
    {
      ru: "Осторожно!",
      rm: "Ostorozhno!",
      en: "Be careful!",
    },
    {
      ru: "Оставьте меня в покое",
      rm: "Ostav'te menya v pokoye",
      en: "Leave me alone",
    },
    {
      ru: "Я голоден/голодна",
      rm: "Ya goloden/golodna",
      en: "I'm hungry (male/female)",
    },
    {
      ru: "Я хочу пить",
      rm: "Ya hochu pit'",
      en: "I'm thirsty",
    },
    {
      ru: "Мне очень жаль",
      rm: "Mne ochen' zhal'",
      en: "I'm very sorry",
    },
    {
      ru: "Поздравляю!",
      rm: "Pozdravlyayu!",
      en: "Congratulations!",
    },
    {
      ru: "Удачи!",
      rm: "Udachi!",
      en: "Good luck!",
    },
    {
      ru: "Счастливого пути!",
      rm: "Schastlivogo puti!",
      en: "Have a good trip!",
    },
    {
      ru: "За здоровье!",
      rm: "Za zdorov'ye!",
      en: "Cheers! (To health)",
    },
    {
      ru: "Это бесплатно?",
      rm: "Eto besplatno?",
      en: "Is it free?",
    },
    {
      ru: "Какой пароль от вайфая?",
      rm: "Kakoy parol' ot vayfaya?",
      en: "What's the wifi password?",
    },
    {
      ru: "Можно сфотографировать?",
      rm: "Mozhno sfotografirovat'?",
      en: "Can I take a picture?",
    },
  ],
};
